
import { Field } from "formik";
import React from "react";
import Form from "react-bootstrap/Form";

const Enquirysix = ({ setFieldValue, errors, touched, values }) => {
  return (
    <>
      <div className="account-created-pop">
        <h3>Tell us a little more</h3>
        {/* <p>What kind of job is this?</p> */}


        {/* Have you had any quotations before? */}
        <div>
          <label>Have you had any quotations before?</label>
          <div className="radio-select-set">
            <label style={{cursor:"pointer"}}>
              <Field type="radio" name="quotation" value="Yes"  style={{cursor:"pointer"}}/>
              Yes
            </label>
            <label style={{cursor:"pointer"}}>
              <Field type="radio" name="quotation" value="No" style={{cursor:"pointer"}} />
              No
            </label>
          </div>
          {touched.quotation && errors.quotation && (
            <div className="error-message">{errors.quotation}</div>
          )}
        </div>

      </div>
    </>
  );
};

export default Enquirysix;

